import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  max-width: 1200px;
  padding: 0 16px;
  margin-bottom: 64px;
`;

export const AccordionWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const AccordionItem = styled.div<{ children: ReactNode }>`
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }
`;

export const AccordionHeader = styled.button<{
  children: ReactNode;
  isOpen: boolean;
  onClick: () => void;
}>`
  width: 100%;
  text-align: left;
  padding: 24px 0;
  background: none;
  border: none;
  display: grid;
  grid-template-columns: 1fr 24px;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  cursor: pointer;
  color: #333;
  font-size: 18px;
  font-weight: 600;

  svg {
    transition: transform 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  }
`;

export const AccordionContentWrapper = styled.div<{
  children: ReactNode;
  isOpen: boolean;
}>`
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease;

  ${({ isOpen }) =>
    isOpen &&
    css`
      grid-template-rows: 1fr;
    `}
`;

export const AccordionContent = styled.div<{
  children: ReactNode;
}>`
  overflow: hidden;
`;

export const AccordionText = styled.p`
  margin: 0;
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
  padding-bottom: 24px;
`;
